module.exports = __webpack_public_path__ + "static/media/nikon_hero.c7b0c9a8.png";